import { Component, OnInit } from '@angular/core';
import { CashboxService } from '../cashbox.service';
import { GlobalDataService } from '../../../../services/global-data.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-cashbox',
  templateUrl: './cashbox.component.html',
  styleUrls: ['./cashbox.component.css'],
  providers: [CashboxService]
})
export class CashboxComponent implements OnInit {

  cashboxes: any = [];
  cashboxTransactionModal : boolean = false;
  closeCashboxModal : boolean = false;
  cashboxes_id: any="";
  cashboxTransaction: any = [];
  loading: boolean = true;
  loadingTransaction: boolean = true;

  constructor(private cashboxService: CashboxService,private global: GlobalDataService) { }

  ngOnInit() {
  		this.loadCashbox();
  }

  loadCashbox(){
       this.cashboxService.getCashBoxListService().subscribe(response=>{this.cashboxes=response.body.data; this.loading=false;}); 
  }


  createCashboxDay(){
    this.loading=true;
  	 let d = new Date();
     let data={ 
        "date" : d.toLocaleDateString(),
        // "store_id" : this.global.user.stores[0].id,
        "store_id" : "",
        "available" : 1

      };

  		this.cashboxService.createCashBoxDayService(data).subscribe(response=>{this.loadCashbox();});
  }


  showTransactionModal(id: any){
    this.cashboxTransactionModal = true;
    this.cashboxTransaction=[];
    this.cashboxService.getCashBoxListByIdService(id).subscribe(response=>{this.cashboxTransaction=response.body.data;this.loadingTransaction=false;});
  }

  showCashboxModal(id: any){
    this.closeCashboxModal = true;
    this.cashboxes_id=id;

  }

  closeCashbox(form: NgForm){

    this.cashboxService.closeCashBoxService(form.value).subscribe(response=>console.log(response));

  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/cashboxes/cashbox/cashbox.component.ts